import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableQrCodesInHtmlPackingSlips = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableQrCodesInHtmlPackingSlips);
};
